import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import packageJson from "../../../../package.json";

@Injectable()
export class OptionsInterceptor {
  constructor(private translate: TranslateService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = request.clone({
      setHeaders: {
        "User-Language": this.translate.currentLang,
        "App-Version": packageJson.version,
      },
    });
    return next.handle(request);
  }
}
